<template>
  <div id="app">

		<!-- drop down menu -->
			<div id="template" style="display: none;">
					<ul class="list-group" style="border:none;">
					<a href="#" class="list-group-item pop" style="border:none;font-size: 16px; "><i class="tt icon-feather-plus-circle"></i> Add new scenario</a>
					<hr />
					<a href="#" class="list-group-item pop" style="border:none;font-size: 16px; color: #334152;"><i class="tt icon-feather-edit"></i> Default scenario</a>
					<a href="#" class="list-group-item pop" style="border:none;font-size: 16px; "><i class="tt icon-feather-edit"></i> Buy a car</a>

					</ul>
					</div>

    <b-navbar toggleable="md" type="light" v-if="isAuthenticated">
  <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
  <b-navbar-brand href="#"><img src="/static/logo3.png" width="60"></b-navbar-brand>
  <b-collapse is-nav id="nav_collapse">
    
		<b-navbar-nav>
			<b-nav-item to="/welcome" >Welcome</b-nav-item>
			<b-nav-item id="scenarioLink" to="/scenario" >Scenario</b-nav-item>
			<b-nav-item to="/outcome" >Outcome</b-nav-item>
      <b-nav-item href="#" disabled>Motivation</b-nav-item>
      <b-nav-item href="#" disabled>About</b-nav-item>
    </b-navbar-nav>
    <!-- Right aligned nav items -->
    <b-navbar-nav class="ml-auto">
      <b-nav-item-dropdown right>
        <!-- Using button-content slot -->
        <template slot="button-content">
					<i class="icon-feather-settings" style="color: #7B1FA2;"></i>
        </template>
        <b-dropdown-item >Register</b-dropdown-item>
				<b-dropdown-item v-on:click="logout">Sign out</b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </b-collapse>
</b-navbar>

<router-view></router-view>

</div>
</template>
<style>
@media (max-width: 768px){
.support-index .support-ticket-content-w {
    display: initial;
}
}
* { font-family: 'Avenir Next W01', sans-serif; }
body:before{
  background: none !important;
  background-color:#f2f4f8 !important; 
}
.all-wrapper {
    -webkit-box-shadow: none;
    box-shadow: none;
    border-radius: 6px;
    max-width: 1600px;
    margin: 0px auto;
    position: relative;
    min-height: 100%;
}

.timed-activity .ta-timestamp {
width: 120px;
}
</style>

<script>
import { sync } from 'vuex-pathify'
import * as moment from 'moment';
import store from './store'
import notie from 'notie'
import axios from 'axios'

function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}
export default {
  name: 'app',
  components: {
  },
  filters: {
    activityDay: function (value) {
      /* 21st Jan, 2019 Wednesday */
      return moment(value).format('Do MMM YYYY dddd')
    },
    activityTime: function (value) {

      return moment(value).format('HH:mm')
    }
  },
  computed: {
    // The sync helper creates two-way bindings for store data and mutations.
    // isAuthenticated: sync('isAuthenticated')
    ...sync(['isAuthenticated', 'u'])
    // We could reduce boilerplate even further using:
    // ...sync(['firstName', 'lastName'])
  },
  data () {
    return {
      newLead: {
        email: '',
        firstName: '',
        surName: '',
        hotelName: '',
        phone: '',
        countryCode: 'CO',
        currency: 'COP',
        timeZone: 'America/Bogota',
        status: 'interested'
      },
      displayAddOp: false,
		}
  },
  methods: {
    
    logout () {
			console.log('logout')
			/*
      window.localStorage.removeItem('crm')
      store.set('isAuthenticated', false)
      store.set('token', '')
      store.set('crmTokenValidTill', '')
      store.set('u', '')
			this.$router.push({name:"login"})
			*/
    },
    fullName (value) {
      return `${value.first} ${value.last}`
    },
    act () {
    }
  },
  mounted () {
		console.log('mnt')
		
		const template = document.getElementById('template')
		tippy('#scenarioLink', {
  		content: template.innerHTML,
			allowHTML: true,
			theme: 'light',
					interactive: true,
					appendTo: document.body
		})
  }
  
}
</script>
